import Vue from 'vue';
import _ from 'lodash';
import {
    GET_CLIENT_LIST_REQUEST,
    GET_CLIENT_LIST_SUCCESS,
    GET_CLIENT_LIST_FAILURE,
    UPDATE_CLIENT_LIST_PARAMS,
    RESET_CLIENT_LIST,
    RESOLVE_CLIENT_LIST_PARAMS
} from '../mutationTypes';

const state = {
    loading: false,
    page: 1,
    pageSize: 10,
    userName: '',
    userMobile: '',
    carNo: '',
    listData: [],
    pageCount: 1,
    customeLevel: 0,   // 消费等级，默认0全部
    reqParams: {},
};

const mutations = {
    // 请求开始
    [GET_CLIENT_LIST_REQUEST](state) {
        state.loading = true;
    },
    // 请求成功
    [GET_CLIENT_LIST_SUCCESS](state, res) {
        state.loading = false;

        state.pageCount = res.page_count;
        state.listData = res.user_list;
    },
    // 请求失败
    [GET_CLIENT_LIST_FAILURE](state) {
        state.loading = false;
        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_CLIENT_LIST_PARAMS](state, params) {
        const {
            userName, userMobile, page, carNo,
        } = params;
        if (userName || userName === '') state.userName = userName;
        if (userMobile || userMobile === '') state.userMobile = userMobile;
        if (carNo || carNo === '') state.carNo = carNo;

        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    // 重置列表数据
    [RESET_CLIENT_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            page: 1,
            pageSize: 10,
            userName: '',
            userMobile: '',
            carNo: '',
            listData: [],
            pageCount: 1,
            customeLevel: 0,
            reqParams: {},
        }));
    },
    [RESOLVE_CLIENT_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getClientList({ commit }) {
        commit(GET_CLIENT_LIST_REQUEST);

        const res = await Vue.$ajax.get('userList', state.reqParams);

        if (!res.errorType) {
            commit(GET_CLIENT_LIST_SUCCESS, res);
        } else {
            commit(GET_CLIENT_LIST_FAILURE);
        }
    },
    resolveClientListParams({ commit }) {
        const params = _.pick(state, ['page']);
        params.user_name = state.userName;
        params.user_mobile = state.userMobile;
        params.custome_level = state.customeLevel;
        params.car_no = state.carNo;
        params.pagesize = state.pageSize;
        commit(RESOLVE_CLIENT_LIST_PARAMS, params);
    },
    resetClientList({ commit }) {
        commit(RESET_CLIENT_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/client.js